import { customAxios } from './customAxios'
export function createNewFolder(idFolder, subFolderName, idPratica) {
  const config = {
    params: {
      idFolder,
      subFolderName,
      idPratica,
    },
    headers: {
      AuthToken: JSON.parse(localStorage.getItem('token')),
    },
  }

  const createNewFolder = customAxios.post(
    process.env.REACT_APP_BACKEND_HOST +
      '/' +
      process.env.REACT_APP_PATH_NEW_PREFIX +
      '/createFolder?',
    null,
    config,
  )
  return createNewFolder
}
